import { CompactTripCheckpoint, EmptyTripInfo } from '@lp/features/RoutePlanner/components/GroundTrip';
import { CheckpointTypeEnum } from '@/api/apis/drive-service';
import { useDriveTripQuery } from '@/queries/drive-service';
import { GroundTripTitle } from './GroundTripTitle';

export type CaseGroundTripInfoProps = {
  tripId: string;
};

export const CaseGroundTripInfo = ({ tripId }: CaseGroundTripInfoProps) => {
  const { data } = useDriveTripQuery(tripId);

  if (!data) return null;

  return (
    <div className="flex flex-col gap-2">
      <GroundTripTitle tripId={data.id} />
      <div className="flex flex-col gap-1 py-3 px-4 bg-white rounded-2xl">
        {data.tripPlan.checkpoints.length ? (
          <>
            {data.tripPlan.checkpoints.map((checkpoint) => {
              const key =
                checkpoint.$type === CheckpointTypeEnum.PlannedCheckpointResponse
                  ? checkpoint.checkpointId
                  : checkpoint.modeData.waitStartTime;

              return (
                <CompactTripCheckpoint
                  key={key}
                  data={checkpoint}
                  tripPassengers={data.passengers}
                  type="case-details"
                />
              );
            })}
          </>
        ) : (
          <EmptyTripInfo message="No trip plan yet" />
        )}
      </div>
    </div>
  );
};
